module.exports = __webpack_public_path__ + "img/ic_order_wait_stop.9363c2a4.png";